var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},_vm._l((_vm.icons()),function(style,styleIndex){return _c('v-icon',{key:`style-${styleIndex}`,staticClass:"mr-1",attrs:{"small":"","title":_vm.MC_ClimbingStylesByStyle[style].text}},[_vm._v("\n    "+_vm._s(_vm.MC_ClimbingStylesByStyle[style].icon)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }